import {
  BaSeBox,
  BaSeBreakpointContext,
  BaSeContainer,
  BaSeDrawer,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { guidanceConfig } from '../configs/guidance-config';
import { entryInnerRoutePaths } from '../models/path-model';
import * as Styled from '../styled/entry-layout-styled';

const {
  defaultColors: { white },
  institucionais: { cinzaSebrae60 },
} = BaSeTheme.colors;

export const EntryContainer: React.FC = ({ children }) => {
  const { inTablet } = React.useContext(BaSeBreakpointContext);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { getActualUri } = Sebrae.useRouter();

  const hasGuidance = React.useMemo(
    () =>
      [
        entryInnerRoutePaths.newStory,
        entryInnerRoutePaths.storyStepsBase,
        entryInnerRoutePaths.storyReview,
        entryInnerRoutePaths.storyResume,
      ].some((innerPath) => getActualUri().includes(innerPath)),
    [getActualUri],
  );

  const renderGuidanceContent = React.useCallback(
    () =>
      guidanceConfig.find(({ innerPath }) => getActualUri().includes(innerPath))
        ?.content,
    [getActualUri],
  );

  return (
    <>
      <Styled.BodyInner>
        <Styled.ContentWrapper>{children}</Styled.ContentWrapper>

        {hasGuidance && inTablet && (
          <Styled.GuidanceSidebar>
            <BaSeBox
              backgroundColor={white}
              borderColor={cinzaSebrae60}
              shadowLevel={0}
              height="100%"
              renderContent={() => <div>{renderGuidanceContent()}</div>}
            />
          </Styled.GuidanceSidebar>
        )}
      </Styled.BodyInner>

      {hasGuidance && !inTablet && (
        <Styled.GuidanceDrawerWrapper>
          <BaSeDrawer
            anchor="right"
            pullerPosition="start"
            width={350}
            height="100%"
            open={drawerOpen}
            onToggle={setDrawerOpen}
          >
            <BaSeContainer>{renderGuidanceContent()}</BaSeContainer>
          </BaSeDrawer>
        </Styled.GuidanceDrawerWrapper>
      )}
    </>
  );
};
